import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeveloperBoard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.66659 14C2.29992 14 1.98603 13.8694 1.72492 13.6083C1.46381 13.3472 1.33325 13.0333 1.33325 12.6667V3.33333C1.33325 2.96667 1.46381 2.65278 1.72492 2.39167C1.98603 2.13056 2.29992 2 2.66659 2H11.9999C12.3666 2 12.6805 2.13056 12.9416 2.39167C13.2027 2.65278 13.3333 2.96667 13.3333 3.33333V4.66667H14.6666V6H13.3333V7.33333H14.6666V8.66667H13.3333V10H14.6666V11.3333H13.3333V12.6667C13.3333 13.0333 13.2027 13.3472 12.9416 13.6083C12.6805 13.8694 12.3666 14 11.9999 14H2.66659ZM3.99992 11.3333H7.33325V8.66667H3.99992V11.3333ZM7.99992 6.66667H10.6666V4.66667H7.99992V6.66667ZM3.99992 8H7.33325V4.66667H3.99992V8ZM7.99992 11.3333H10.6666V7.33333H7.99992V11.3333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDeveloperBoard);
export default ForwardRef;
